import { useState } from "react";
import { Dropdown, Form } from "react-bootstrap";

interface SearchableSelectProps {
    options: string[];
    value: string;
    onChange: (value: string) => void;
    placeholder?: string;
    disabled?: boolean;
}

const SearchableSelect = ({ options, value, onChange, placeholder = "Select", disabled = false }: SearchableSelectProps) => {
    const [searchText, setSearchText] = useState("");

    const getFilteredOptions = () => {
        if (!searchText) return options;
        return options.filter((item) =>
            item.toLowerCase().includes(searchText.toLowerCase())
        );
    };

    const handleSelect = (opt: string) => {
        onChange(opt);
        setSearchText("");
    };

    return (
        <Dropdown className="w-100" onToggle={(isOpen) => { if (!isOpen) setSearchText(""); }}>
            <Dropdown.Toggle
                as="div"
                disabled={disabled}
                className="form-control text-start d-flex justify-content-between align-items-center"
                role="button"
                style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    backgroundColor: disabled ? "#e9ecef" : "#fff",
                    cursor: disabled ? "default" : "pointer",
                }}
            >
                <span style={{ overflow: "hidden", textOverflow: "ellipsis" }}>
                    {value || placeholder}
                </span>
            </Dropdown.Toggle>
            <Dropdown.Menu style={{ width: "100%", maxHeight: "250px", overflowY: "auto" }}>
                <div className="px-2 pb-2">
                    <Form.Control
                        type="text"
                        placeholder="Search timezone..."
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        onClick={(e) => e.stopPropagation()}
                    />
                </div>
                {getFilteredOptions().length > 0 ? (
                    getFilteredOptions().map((item, index) => (
                        <Dropdown.Item
                            key={item + index}
                            onClick={() => handleSelect(item)}
                            style={item === value ? { backgroundColor: "#f0f0f0", color: "#212529" } : {}}
                        >
                            {item === value ? `✓ ${item}` : item}
                        </Dropdown.Item>
                    ))
                ) : (
                    <Dropdown.Item disabled>No matches found</Dropdown.Item>
                )}
            </Dropdown.Menu>
        </Dropdown>
    );
};

export default SearchableSelect;
